import gql from 'graphql-tag'

export default gql`
  query getCentres($q: String!) {
    centres(q: $q) {
      title
      state
      country
      slug
      suburb
      status
      longitude
      latitude
    }
  }
`
